<template>
  <IconLucideCornerLeftUp />
</template>
